module.exports = __webpack_public_path__ + "static/media/log-file.d5483d2c.svg";